import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import './SLogin.css'

const FBLoginUI = ({context, messageList, onClick}) =>
  <button
    className="s_login fb_login"
    onClick={onClick}
    type="button"
  >
    <em></em>
    <MessageUI messageList={messageList} messageKey='c_login_with_fb' />
  </button>

export default FBLoginUI
